export default __webpack_public_path__ + "static/media/video.eb1a44dc.mp4";